// Imágenes del catálogo en Dexie (tabla imagenes, v2). Solo URLs http(s): las data: ya vienen en el JSON.
// Se descarga solo si la URL no está guardada (una URL nueva = imagen cambiada).
import { db } from '@/db/posDb';

const esUrl = (img) => typeof img === 'string' && /^https?:\/\//i.test(img);

// URL final de una imagen del catálogo (antes en VentaPOS.getImageUrl). Los productos y promos llegan con URL
// absoluta o data:image…; los paquetes, con la ruta en /storage o con base64 sin prefijo.
export function urlImagen(img) {
  if (!img) return null;
  if (img.startsWith('http') || img.startsWith('data:')) return img;
  if (/\.(jpeg|jpg|gif|png|webp|svg)$/i.test(img)) {
    return process.env.VUE_APP_ROOT_API.replace(/\/api$/, '') + '/storage/' + img;
  }
  return 'data:image/png;base64, ' + img;
}

const urlsDelCatalogo = (productos) => [...new Set((productos || []).map((p) => urlImagen(p.imagen)).filter(esUrl))];

export async function guardarImagenesCatalogo(productos) {
  const urls = urlsDelCatalogo(productos);
  const guardadas = new Set(await db.imagenes.where('url').anyOf(urls).primaryKeys());
  for (const url of urls.filter((u) => !guardadas.has(u))) {
    try {
      const r = await fetch(url, { cache: 'no-store' });
      if (!r.ok) continue; // 404: se usará la imagen de reemplazo
      const blob = await r.blob();
      await db.imagenes.put({ url, blob, tipo: blob.type, guardado_en: new Date().toISOString() });
    } catch (e) {
      // Red o CORS: sin blob para esta URL; offline se verá la imagen de reemplazo
    }
  }
  // Las que ya no usa ningún producto se borran
  await db.imagenes.filter((i) => !urls.includes(i.url)).delete();
}

// { url: objectURL } para las imágenes guardadas. Quien las use debe revocarlas al salir (revocarUrls).
export async function resolverUrlsImagenes(productos) {
  const urls = urlsDelCatalogo(productos);
  const filas = await db.imagenes.where('url').anyOf(urls).toArray();
  return Object.fromEntries(filas.map((f) => [f.url, URL.createObjectURL(f.blob)]));
}

export function revocarUrls(mapa) {
  Object.values(mapa || {}).forEach((u) => URL.revokeObjectURL(u));
}
